import { Tag } from "@redotech/redo-common-model-tags-common/tag";
import { fgFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import TagIcon from "@redotech/redo-icons/tag-01.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-views-common/advanced-filters/array-string-filter";
import {
  AdvancedTableFilter,
  ArrayStringTableFilter,
} from "@redotech/redo-web/advanced-filters/advanced-filter";
import {
  BadgePillThemeToColorMapping,
  BadgePillThemeToTypeMapping,
} from "@redotech/redo-web/tags/tag-pill";

const entry = fgFilterEntries.tagName;

export const TagFilter = (
  fetcher: (
    { filters }: { filters: AdvancedTableFilter[] },
    signal: AbortSignal,
  ) => Promise<Tag[]>,
): ArrayStringTableFilter<Tag | string> => ({
  type: entry.type,
  itemLabel: "Redo fulfillment tag",
  operators: entry.operators,
  data: {
    name: entry.name,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.ALL_OF,
  },
  Icon: TagIcon,
  valueFetcher: fetcher,
  itemGenerator: (item: Tag | string) => ({
    id: typeof item === "string" ? item : item.name,
    value: item,
    type: "badge",
    badge: {
      text: typeof item === "string" ? item : item.name,
      color:
        typeof item === "string"
          ? undefined
          : BadgePillThemeToColorMapping[item.pillTheme],
      type:
        typeof item === "string"
          ? undefined
          : BadgePillThemeToTypeMapping[item.pillTheme],
    },
  }),
  stringify: (item: Tag | string) =>
    typeof item === "string" ? item : item.name,
  display: (item: Tag | string) =>
    typeof item === "string" ? item : item.name,
  displayName: entry.displayName,
});
